<template>
  <div>
    <div class="coupon-input-form" v-if="isEditing">
      <div class="form-group">
        <label>
          <p>タイトル</p>
          <input
            type="text"
            v-model="coupon.title"
            class="coupon-editor-title"
          />
        </label>
        <!-- quill-editor を label で囲ってしまうとデフォルトで太字になるため for を使う -->
        <label for="coupon-editor-body">
          <p>コンテンツ</p>
        </label>
        <quill-editor
          id="coupon-editor-body"
          v-model="coupon.body"
          :options="editorOptions"
        />
        <div class="form-group__footer">
          <a class="btn-green" @click="onEndEdit()">追加</a>
          <a class="btn-green" @click="onDeleteInput()">削除</a>
        </div>
      </div>
    </div>
    <div class="coupon-input-preview input-preview" v-else>
      <div class="coupon">
        <h4 class="coupon__title">
          {{ coupon.title }}
        </h4>
        <div
          class="coupon__body"
          v-html="coupon.body.replace(/\n/g, '<br/>')"
        />
      </div>
      <footer-menu
        :onDeleteInput="onDeleteInput"
        :onBeginEdit="onBeginEdit"
        :onPullUp="onPullUp"
        :onPullDown="onPullDown"
        :index="index"
      />
    </div>
  </div>
</template>

<script>
import footerMenu from './input-footer-menu.vue';

const toolbar = [
  [{ table: 'newtable_3_2' }, { table: 'append-row' }, { table: 'append-col' }],
  ['bold', 'italic', 'underline', 'strike'],
  ['image', 'link'],

  [{ color: [] }],
  [{ align: [] }],

  ['clean'],
];

export default {
  name: 'couponEditor',
  components: {
    'footer-menu': footerMenu,
  },
  props: {
    value: Object,
    index: Number,
    id: String,
  },
  data() {
    return {
      isEditing: false,
      coupon: {
        title: this.value.title,
        body: this.value.body,
      },
    };
  },
  computed: {
    bodyJSON() {
      return {
        value: {
          coupon_id: this.value.coupon_id ? this.value.coupon_id : null,
          title: this.coupon.title,
          body: this.coupon.body,
        },
        action: 'coupon',
        id: this.id,
      };
    },
    editorOptions() {
      return {
        modules: {
          table: true,
          toolbar,
        },
      };
    },
  },
  methods: {
    onBeginEdit() {
      this.isEditing = true;
    },
    onEndEdit() {
      if (this.coupon.title.length === 0) {
        alert('タイトルを入力してください');
        return false;
      }
      if (this.coupon.body.length === 0) {
        alert('コンテンツを入力してください');
        return false;
      }
      this.isEditing = false;
    },
    onDeleteInput() {
      bus.$emit('delete-input', this.index);
    },
    onPullUp() {
      bus.$emit('pull-up-item', this.index);
    },
    onPullDown() {
      bus.$emit('pull-down-item', this.index);
    },
  },
};
</script>

<style lang="scss" scoped>
.quill-editor ::v-deep button.ql-table[value='newtable_3_2']::after {
  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAABcSURBVEhL3YsxDgBACML8/6fvNhd0aGCyCUuBOsULR5hGToStSHl8oB4fqMcH6rtIRZhGToStSHl8oB4fqMcH6rtIRZhGToStSHl8oB4fqMcH6rtIRZhGTk5Q9QFCcv8BMZAsCwAAAABJRU5ErkJggg==');
}

.coupon-input-form {
  background-color: #eee;
  position: relative;
  padding: 15px 15px 1px;
  margin: 0 0 10px;

  h2 {
    font-size: 14px;
    margin: 0 0 10px;
  }
}

.coupon-editor-title {
  width: 100%;
  padding: 8px;
  border: 1px solid lightgray;
  border-radius: 4px;
  font-size: 14px;
  margin-bottom: 10px;
}

#coupon-editor-body {
  ::v-deep {
    img {
      max-width: 300px;
    }
  }
}

.form-group {
  &__item {
    &:nth-child(n + 2) {
      margin-top: 8px;
    }
  }

  &__footer {
    &:nth-child(n + 2) {
      margin-top: 12px;
    }
  }
}

.ql-editor {
  font-size: 15px;
}

.coupon {
  border: 1px solid lightgrey;
  border-radius: 4px;
  padding: 12px;
  font-size: 14px;

  &__head {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  &__title {
    margin-top: 12px;
    font-size: 20px;
    padding-bottom: 8px;
    border-bottom: 1px solid lightgray;
  }

  &__body {
    margin-top: 8px;
    white-space: pre-wrap;

    ::v-deep {
      $border: 1px solid #efefef;

      table {
        min-width: 100%;
      }

      img {
        max-width: 300px;
      }

      tr {
        border-top: $border;

        &:last-child {
          border-bottom: $border;
        }
      }

      td {
        padding: 8px 12px;
        border-left: $border;

        &:last-child {
          border-right: $border;
        }
      }
    }
  }
}
</style>
